import {
    GET_REVENUE_FROM_SUBSCRIPTION_LOADING,
    GET_REVENUE_FROM_SUBSCRIPTION_SUCCESS

} from '../actions/RevenueFromSubscriptionActions';

const initialState = {
    revenueFromSubscriptionData: null,
    isLoading: true,
};

const RevenueFromSubscriptionReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case GET_REVENUE_FROM_SUBSCRIPTION_SUCCESS:
            return { ...state, revenueFromSubscriptionData: action.data, isLoading: false };

        case GET_REVENUE_FROM_SUBSCRIPTION_LOADING:
            return { ...state, isLoading: action.isLoading };

        default:
            return state;
    }
};

export default RevenueFromSubscriptionReducer;
